import React, { useEffect } from "react";
import { CircularProgress, Dialog } from "@material-ui/core";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import debounce from "lodash/debounce";
import OrderLogViewer from "./viewers/OrderLogViewer";
import OrderProcessLogViewer from "./viewers/OrderProcessLogViewer";
import { useDispatch, useSelector } from "react-redux";
import { getByAuditLogById } from "../../../actions/audit_logs_actions";

import { makeStyles } from "@material-ui/core";
const useStyles = makeStyles(() => ({
  root: {
    "& *": {
      userSelect: "text",
      pointerEvents: "all",
    },
  },
}));

export default function LogDetailsDialog(props) {
  const { isOpen, onClose, id } = props;
  const classes = useStyles();
  const dispatch = useDispatch();

  const isLoading = useSelector((state) => state.auditLogs.isLoading);

  const item = useSelector((state) => {
    return state.auditLogs?.data?.result || {};
  });

  const handleCancel = () => {
    onClose();
  };

  useEffect(() => {
    const debouncedDispatch = debounce(() => {
      if (id) {
        dispatch(getByAuditLogById(id));
      }
    }, 300); // 300ms debounce

    debouncedDispatch();

    return () => {
      debouncedDispatch.cancel(); // Cancel any pending call on cleanup
    };
  }, [dispatch, id]);

  return (
    <Dialog
      dir="ltr"
      onClose={(event, reason) => {
        handleCancel();
      }}
      open={isOpen}
      style={{ over: "scroll" }}
    >
      
      <div style={{ top: "20px", right: "20px", position: "absolute" }}>
        <i className={`fas fa-times`} onClick={handleCancel} />
      </div>
      <DialogTitle style={{ textAlign: "center" }}>Log Details </DialogTitle>
      <DialogContent>
        {isLoading ? (
        <div
          style={{
            height: 300,
            width: 300,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <CircularProgress />
        </div>
      ) : null}
        <div className={classes.root}>
          {item?.linked_class == "Order" ? (
            <OrderLogViewer item={item} />
          ) : null}
          {item?.linked_class == "OrderProcess" ? (
            <OrderProcessLogViewer item={item} />
          ) : null}
        </div>
      </DialogContent>
      <DialogActions></DialogActions>
    </Dialog>
  );
}
